module.exports = __webpack_public_path__ + "00_mole.1f63ce66.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer2/00_mole.png
// module id = 4VMN
// module chunks = 0